import { NextPage } from 'next';
import React from 'react';
import { Header } from 'components/structures';
import DetailPage from '../../containers/expertise/DetailPage';
import { dataCenters, dataCentersCapabilitiesHero } from '../../images/expertise/data-centers-capabilities';

const DataCentersCapabilities: NextPage = () => {
  return (
    <>
      <Header
        title="Data Centers Capabilities"
        description="At Utilities One, we specialize in maintaining and optimizing data centers to ensure secure and efficient operations. Our innovative solutions and commitment to excellence support seamless digital infrastructure."
        image={dataCentersCapabilitiesHero}
      />
      <DetailPage
        listBlocks={[
          {
            bgImage: dataCenters,
            id: 'oilGas',
            hasListItems: true,
            title: 'Data Centers',
            description:
              'Comprehensive services for building and maintaining cutting-edge data centers tailored to meet diverse industry needs.',
            listItems: [
              {
                boldText: 'Design & Construction:',
                text: 'Robust structures, primary and backup power systems, and advanced HVAC solutions.',
              },
              {
                boldText: 'Networking Infrastructure:',
                text: 'Installation of routers, switches, and structured cabling for seamless connectivity.',
              },
              {
                boldText: 'Security Systems:',
                text: 'Biometric access, surveillance, and fire suppression for asset protection.',
              },
              {
                boldText: 'Compliance Standards:',
                text: 'Adherence to ISO, Tier certifications, and local regulations.',
              },
            ],
          },
        ]}
      />
    </>
  );
};

export default DataCentersCapabilities;
